import styled from 'styled-components';

export const Select = styled.select`
  width: 100%;
  height: 42px;
  line-height: 42px;
  padding: 0 0.6em;
  border: ${props => props.theme.inputBorders};
  font-size: 16px;
  box-sizing: border-box;
`;
